import Constants from '../constants.js'

import AuthUtil from '../authUtil'

import axios from 'axios'

export default {
  async validateOneTimeCode (code, resourcePath) {
    const appCheckToken = await AuthUtil.getAppCheckToken()
    const checkEndpoint = `${Constants.API_BASE_PATH}/users/validateonetimecode`

    const response = await axios.post(checkEndpoint, {code: code, resourcePath: resourcePath}, {
      headers: {
        'Content-Type': 'application/json',
        'X-Firebase-AppCheck': appCheckToken
      }
    })

    if (response && response.status === 200 && response.data && response.data.valid) {
      return true
    } else {
      return false
    }
  }
}
